import { Component, OnInit } from '@angular/core';
import Environment from '@env';
import { HttpService } from 'src/app/modules/core/services/http.service';
import { APP_VERSION_NUMBER } from 'src/app/version';

@Component({
    selector: 'topo-version-check',
    templateUrl: './version-check.component.html',
    styleUrls: ['./version-check.component.scss'],
    standalone: false
})
export class VersionCheckComponent implements OnInit {
  isActive = false;
  seconds = 10;
  timeoutHandle = null;
  pollingInterval = Environment.versionCheckInterval || 600000; // 10 minutes
  cancelCountDown = false;

  constructor(private httpService: HttpService) {}

  ngOnInit(): void {
    // init the app version checker, this will cause the app to refresh
    // when a new version is available.
    this.checkAppVersion();
  }

  checkAppVersion(): void {
    const dt = new Date().getTime();
    this.httpService.get(`/version.json?d=${dt}`).subscribe(
      data => {
        if (data?.version && APP_VERSION_NUMBER !== data?.version) {
          this.isActive = true;
          this.seconds = 20;
          this.cancelCountDown = false;
          this.runCountdown();
        } else {
          setTimeout(() => {
            this.checkAppVersion();
          }, this.pollingInterval);
        }
      },
      err => {
        console.warn('Could not find ./version.json');
        setTimeout(() => {
          this.checkAppVersion();
        }, this.pollingInterval);
      }
    );
  }

  reload(): void {
    if (this.timeoutHandle) {
      clearTimeout(this.timeoutHandle);
      this.timeoutHandle = null;
    }
    window.location.reload();
  }

  cancelRefresh(): void {
    this.cancelCountDown = true;
    this.isActive = false;
    if (this.timeoutHandle) {
      clearTimeout(this.timeoutHandle);
      this.timeoutHandle = null;
    }

    setTimeout(() => {
      this.checkAppVersion();
    }, this.pollingInterval);
  }

  runCountdown(): void {
    this.timeoutHandle = setTimeout(() => {
      this.seconds--;
      if (this.seconds === 0) {
        this.reload();
      } else if (!this.cancelCountDown) {
        this.runCountdown();
      }
    }, 1000);
  }
}
